import React from 'react';
import PropTypes from 'prop-types';
import {getSvgStoreSrcEntry} from 'common/utils/statics-util';
import classNames from 'classnames';

export default class SvgSymbol extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    name: PropTypes.string,
    // Path to bundle
    path: PropTypes.string,
    // UseImg workaround, used by PDF/image export:
    // PhantomJS (1.9.8) does not render SVG symbols, base64 encoded background images, etc
    style: PropTypes.object,
    useImg: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
    name: null,
    path: null,
    style: {},
    useImg: false,
  };

  render() {
    const {name, path, style, useImg} = this.props;

    if (!name) {
      // If name is empty, don't render anything
      // Allows <SvgSymbol name={possiblyNullIcon} /> pattern, no need for check
      return null;
    }

    const className = classNames('SvgSymbol', 'svg-symbol', {
      [`${this.props.className}`]: this.props.className,
    });

    return useImg ? (
      <img
        alt={''}
        className={className}
        src={path ? `${path}${name}.svg` : getSvgStoreSrcEntry(name)}
        style={style}
      />
    ) : (
      <svg
        aria-hidden={true}
        className={className}
        data-icon={name}
        style={style}>
        <use
          xlinkHref={path ? `${path}#${name}` : `#svg-icon-${name}`}
          xmlnsXlink={'http://www.w3.org/1999/xlink'}
        />
      </svg>
    );
  }
}
